/**
 * Gateway Domain Configuration
 *
 * URLs relativas para que nginx proxee /api/v2 al backend.
 * En desarrollo local, Vite proxy hace lo mismo.
 */
export const GW_DOMAIN = "";

export const API_V2 = "/api/v2";
